import { isDevEnv } from './isDevEnv';

export function logWarn(...args) {
  return (isDevEnv() || window.__DN?.DEBUG) && console.warn(...args); // eslint-disable-line no-console
}
